import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  CHANGE_INPUT_TEST: "change_input_article",
  CHANGE_OBJECT_TEST: "change_object_test",
  CHANGE_INPUT_OBSERVATION: "change_input_observation",
  RELOAD_OBSERTATIONS: "reload_observations",
  RELOAD_DOCUMENTS: "reload_documents",
  RELOAD_VERSIONS: "reload_versions",

  RELOAD_ITEMS_TEST: "reload_items_test",
  SET_TEST_ID: "set_test_id",
  CHANGE_PAYLOAD_TEST: "change_payload_test",
  OBSERVATIONS_LOADED: "observations_loaded",
  DOCUMENTS_LOADED: "documents_loaded",

  VERSIONS_LOADED: "versions_loaded",

  ITEMS_TEST_LOADED: "items_test_loaded",
  CHANGE_INPUT_TEST_FORM: "change_input_test_form",
  ITEMS_FOUND: "items_found",
  CHANGE_STATUS_LOOK_FOR_CODE: "change_status_look_for_code",
  REMOVE_ITEM: "remove_item",
  CHANGE_INPUT_NEW_VERSION: "change_input_new_version",
  SET_PANEL_OBSERVATION: "set_panel_observation",
  TOGGLE_PANEL_OBSERVATION: "toggle_panel_observation",
  CLEAN_FORM_NEW_VERSION_AND_RELOAD: "clean_form_new_version_and_reload",
};
export const INITIAL_STATE = {
  lookForCode: "",
  lookForItemStatus: STATUS_NOT_LOADED,
  lookedItems: [],
  test: {
    id: null,
    name: "",
    type: null,
    created_at: new Date(),
    is_active: false,
    reference: "",
    item_id: null,
    parent_id: null,
    item_name: "",
    item_code: "",
    item_presentation: "",
    item_quantity: 0,
    to_edit: true,
    test_version: {
      version_id: null,
      version: null,
      description: "",
      panelObservation: {
        up: false,
        watchDocuments: false,
      },
    },
    observation: {
      text: "",
      status: STATUS_NOT_LOADED,
      observations: [],
    },
    items_test: {
      status: STATUS_NOT_LOADED,
      items: [],
    },
    version_list: {
      status: STATUS_NOT_LOADED,
      versions: [],
    },
    document: {
      status: STATUS_NOT_LOADED,
      documents: [],
    },
  },
};
export const testReducer = (state, action) => {
  const payload = action.payload;
  const {
    CHANGE_INPUT_TEST,
    CHANGE_OBJECT_TEST,
    CHANGE_INPUT_OBSERVATION,
    RELOAD_OBSERTATIONS,
    RELOAD_DOCUMENTS,
    RELOAD_ITEMS_TEST,
    SET_TEST_ID,
    CHANGE_PAYLOAD_TEST,
    OBSERVATIONS_LOADED,
    DOCUMENTS_LOADED,
    CHANGE_INPUT_TEST_FORM,
    ITEMS_FOUND,
    CHANGE_STATUS_LOOK_FOR_CODE,
    ITEMS_TEST_LOADED,
    REMOVE_ITEM,
    RELOAD_VERSIONS,
    VERSIONS_LOADED,
    CHANGE_INPUT_NEW_VERSION,
    TOGGLE_PANEL_OBSERVATION,
    SET_PANEL_OBSERVATION,
    CLEAN_FORM_NEW_VERSION_AND_RELOAD,
  } = types;
  switch (action.type) {
    case SET_PANEL_OBSERVATION:
      return {
        ...state,
        test: {
          ...state.test,
          test_version: {
            ...state.test.test_version,
            panelObservation: {
              ...state.test.test_version.panelObservation,
              watchDocuments: action.payload,
            },
          },
        },
      };

    case TOGGLE_PANEL_OBSERVATION:
      return {
        ...state,
        test: {
          ...state.test,
          test_version: {
            ...state.test.test_version,
            panelObservation: {
              ...state.test.test_version.panelObservation,
              up: !state.test.test_version.panelObservation.up,
            },
          },
        },
      };
    case CHANGE_INPUT_NEW_VERSION:
      return {
        ...state,
        test: {
          ...state.test,
          test_version: {
            ...state.test.test_version,
            [payload.name]: payload.value,
          },
        },
      };
    case CLEAN_FORM_NEW_VERSION_AND_RELOAD:
      return {
        ...state,
        test: {
          ...state.test,
          version_list: {
            ...state.test.version_list,
            status: STATUS_NOT_LOADED,
          },
          test_version: {
            ...state.test.test_version,
            description: "",
            version: null,
          },
        },
      };
    case CHANGE_INPUT_TEST:
      return {
        ...state,
        test: {
          ...state.test,
          [payload.name]: payload.value,
        },
      };
    case CHANGE_OBJECT_TEST:
      return {
        ...state,
        test: payload,
      };
    case CHANGE_INPUT_OBSERVATION:
      return {
        ...state,
        test: {
          ...state.test,
          observation: {
            ...state.test.observation,
            [payload.name]: payload.value,
          },
        },
      };
    case SET_TEST_ID:
      return {
        ...state,
        test: {
          ...state.test,
          id: action.payload,
        },
      };
    case RELOAD_OBSERTATIONS:
      return {
        ...state,
        test: {
          ...state.test,
          observation: {
            ...state.test.observation,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_ITEMS_TEST:
      return {
        ...state,
        test: {
          ...state.test,
          items_test: {
            ...state.test.items_test,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_DOCUMENTS:
      return {
        ...state,
        test: {
          ...state.test,
          document: {
            ...state.test.document,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_VERSIONS:
      return {
        ...state,
        test: {
          ...state.test,
          version_list: {
            ...state.test.version_list,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case CHANGE_PAYLOAD_TEST:
      return {
        ...state,
        test: payload,
      };
    case DOCUMENTS_LOADED:
      return {
        ...state,
        test: {
          ...state.test,
          document: {
            ...state.test.document,
            documents: payload,
            status: LOADED,
          },
        },
      };
    case OBSERVATIONS_LOADED:
      return {
        ...state,
        test: {
          ...state.test,
          observation: {
            ...state.test.observation,
            observations: payload,
            status: LOADED,
          },
        },
      };
    case VERSIONS_LOADED:
      return {
        ...state,
        test: {
          ...state.test,
          version_list: {
            ...state.test.version_list,
            versions: payload,
            status: LOADED,
          },
        },
      };
    case ITEMS_TEST_LOADED:
      return {
        ...state,
        test: {
          ...state.test,
          items_test: {
            ...state.test.items_test,
            items: payload,
            status: LOADED,
          },
        },
      };

    case CHANGE_INPUT_TEST_FORM:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case CHANGE_STATUS_LOOK_FOR_CODE:
      return {
        ...state,
        lookForItemStatus: action.payload,
      };
    case ITEMS_FOUND:
      return {
        ...state,
        lookForItemStatus: LOADED,
        lookedItems: action.payload,
      };
    case REMOVE_ITEM:
      return {
        ...state,
        lookForCode: "",
        lookedItems: [],
        test: {
          ...state.test,
          item_id: null,
          item_name: "",
          item_code: "",
          item_presentation: "",
          item_quantity: 0,
        },
      };
    default:
      return state;
  }
};
